<template>
  <div class="view-pg support-pg">
    <v-container>
      <div class="breadcrumbs-wrap">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      </div>
      <h1 class="title-pg">{{ this.details.question }}</h1>
      <div class="support">
          <SupportSearch />
          <div 
            class="support_block"
            v-if="emptyList"
          >
            <!--список-->
            <div class="support_list">
              <SupportList 
                :list="list" 
              />
            </div>
            <!--деталь-->
            <div class="support_details">
              <SupportDetails />
            </div>
          </div>
          <div 
            v-else
            class="support_empty"
          >
            <h2> Ничего не найдено </h2>
          </div>
      </div>
    </v-container>
  </div>
</template>
<script>
import { mapMutations, mapGetters } from 'vuex'

/* import support list */
import support from '@/model/support'

/* import components */
import SupportSearch from '@/components/support/SupportSearch.vue'
import SupportList from '@/components/support/SupportList.vue'
import SupportDetails from '@/components/support/SupportDetails.vue'

export default {
  components: {
    SupportDetails,
    SupportList,
    SupportSearch
  },
  mounted() {
    this.scrollToTop()
  },
  data: () => ({
    search: {}
  }),
  computed: {
     ...mapGetters({
      searchText: 'getSearchText',
      details: 'getSupportDetails'
    }),

    list () {  
      if (this.searchText == '') {
        return support.getSupportList()
      }

      return support.searchSort(support.getSupportList(), this.searchText)
    },

    emptyList () {
      return this.list?.length > 0
    },

    breadcrumbs() {
      return  [
        {
          text: this.$i18n.t('Главная'),
          disabled: false,
          href: '/'
        },
        {
          text: this.$i18n.t('Поддержка'),
          disabled: false,
          href: '/support'
        },
        {
          text: this.details.question,
          disabled: true
        }
      ]
    },
  },
  methods: {
    ...mapMutations(['setLoading']),
    // Прокручивание к началу страницы
    scrollToTop() {
      window.scrollTo(0, 0)
    },
  },
}
</script>
<style lang="scss" scoped>
  .support {
    width: 100%;
    background-color: #fff;
    padding: 15px;
    padding-bottom: 100px;
    min-height: 80vh;

    &_empty {
      
      h2 {
        color: #7b7b7b;
        font-size: 18px;
      }
    }

    &_block {
      display: flex;
      margin-top: 50px;
      
      @media (max-width: 1024px) {
        flex-direction: column;
      }
    }

    &_details {
      width: calc(100% - 300px);
      margin-left: auto;
      
      @media (min-width: 1024px) {
        overflow-y: scroll;
        max-height: 80vh;
        position: relative;
        padding-bottom: 200px;
      }

      @media (max-width: 1024px) {
        width: 100%;
        margin-top: 40px;
      }
    }
  }

  ::-webkit-scrollbar {
    width: 0;
  }
</style>